import script from "./CampaignCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignCard.vue?vue&type=script&setup=true&lang=js"

import "./CampaignCard.vue?vue&type=style&index=0&id=9c357b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c357b10"]])

export default __exports__